const david = require('@/data/people/david-prenninger.json');

const users = {
  'david-prenninger': david,
};

export default users;
